const DB_NAME = 'buddy-private-assets';
const STORE_NAME = 'avatars';

const openDb = () => new Promise((resolve, reject) => {
  if (!window.indexedDB) { resolve(null); return; }
  const request = window.indexedDB.open(DB_NAME, 1);
  request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME);
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

export const getLocalBuddyAvatar = async (buddyId) => {
  const db = await openDb();
  if (!db) return '';
  return new Promise((resolve, reject) => {
    const request = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(String(buddyId));
    request.onsuccess = () => resolve(request.result || '');
    request.onerror = () => reject(request.error);
  });
};

export const setLocalBuddyAvatar = async (buddyId, dataUrl) => {
  const db = await openDb();
  if (!db) return;
  await new Promise((resolve, reject) => {
    const request = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME).put(dataUrl, String(buddyId));
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const deleteLocalBuddyAvatar = async (buddyId) => {
  const db = await openDb();
  if (!db) return;
  await new Promise((resolve, reject) => {
    const request = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME).delete(String(buddyId));
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};
